const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export async function registerServiceWorker() {
    if (isLocalhost || !("serviceWorker" in navigator)) return;

    try {
        const reg = await navigator.serviceWorker.register("/serviceworker.js");

        // Force check on every load
        reg.update?.();

        reg.addEventListener("updatefound", () => {
            const newWorker = reg.installing;
            if (!newWorker) return;

            newWorker.addEventListener("statechange", () => {
                if (newWorker?.state === "installed" && navigator.serviceWorker.controller) {
                    // New version ready!
                    // showUpdateToast(() => {
                    //     newWorker.postMessage({ type: "SKIP_WAITING" });
                    // });
                    newWorker.postMessage({ type: "SKIP_WAITING" });
                }
            });
        });

        // After skipWaiting, reload when new SW takes control
        navigator.serviceWorker.addEventListener("controllerchange", () => {
            window.location.reload();
        });

        console.log("Service Worker registered");
    } catch (err) {
        console.error("SW registration failed:", err);
    }
}